import React, { Fragment } from "react";

import { ProvideAuth } from "hooks/Auth";
import { ProvideContextualHelp } from "hooks/Help";

const providers = [ProvideAuth, ProvideContextualHelp];

export function combineProviders(providers = []) {
    return providers.reduce(
        (ParentProvider, CurrentProvider) => {
            return ({ children }) => {
                return (
                    <ParentProvider>
                        <CurrentProvider>{children}</CurrentProvider>
                    </ParentProvider>
                );
            };
        },
        ({ children }) => <Fragment>{children}</Fragment>
    );
}

export const ApplicationContextProvider = combineProviders(providers);
